<template>
    <div>
      <b-modal v-model="showModal"
        title="Cambiar Estado"
        header-bg-variant="secondary"
        header-text-variant="white"
        scrollable
        @close="close"
        @show="getRecord"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc>
          <p>Seleccione el nuevo estado para el usuario <strong>{{ code }}</strong>:</p>
          <div class="form-group">
            <select v-model="form.status" class="form-control">
              <option :value="1">Activo</option>
              <option :value="0">Bloqueado</option>
              <option :value="3">Bloqueado permanentemente</option>
            </select>
          </div>
          <small class="text-muted d-block">Un usuario que no esté <b>Activo</b> no podrá iniciar sesión.</small>
          <small class="text-muted d-block mt-1">
            El estado no tiene que ver con la validación del correo: un usuario <b>Activo</b>
            con el correo sin validar tampoco puede entrar. Eso se resuelve desde «Activar».
          </small>
          <div class="modal-footer">
            <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
            <button @click="submit" class="btn btn-sm btn-success"> <i class="fas fa-check fa-fw"></i> Aceptar</button>
          </div>
      </b-modal>
    </div>
  </template>

  <script>
  import 'bootstrap-vue/dist/bootstrap-vue.css';
  import { BModal } from 'bootstrap-vue';

  export default {
    components: {BModal},
    props: ['id','code', 'showModal'],
    data() {
      return {
        form: {
          id: null,
          status: 1,
        },
        loading: false,
      }
    },
    methods:{
      close(bvModalEvent) {
        this.$emit('update:showModal', false)
        this.$emit('getRecords')
      },
      getRecord() {
        this.loading = true
        // Antes se fijaba status: 1 a ciegas, así que el desplegable se abría
        // siempre en "Activo" sin importar el estado real de la cuenta.
        this.form = {
          id: this.id,
          status: 1
        }
        axios.get(`/configuration/users/${this.id}`)
          .then(response => {
            this.form.status = response.data.status
          })
          .catch(error => {
            console.error(error);
            toastr.error('No se pudo cargar el estado del usuario.', 'Error', { icon: 'fa fa-times-circle' });
          })
          .finally(() => { this.loading = false })
      },
      submit() {
        this.loading = true
        axios.get(`/configuration/users/changeStatus/${this.form.id}`, { params: { status: this.form.status } })
          .then(response => {
            if (response.data.status == 'error') {
              toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
            } else {
              toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
            }
            this.close();
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }

  </script>
